export default __webpack_public_path__ + "static/media/IMG_20200127_154754_699.9165341e.jpg";